module.exports = __webpack_public_path__ + "img/ic-pt-cuffs.a5a53035.svg";